import { render, staticRenderFns } from "./AllowanceDecrementMonitor.vue?vue&type=template&id=8a7cc63e"
import script from "./AllowanceDecrementMonitor.vue?vue&type=script&lang=js"
export * from "./AllowanceDecrementMonitor.vue?vue&type=script&lang=js"
import style0 from "./AllowanceDecrementMonitor.vue?vue&type=style&index=0&id=8a7cc63e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports